<template lang="pug">
  b-input-group(:prepend="$t('ui.date')" size="sm")
    date-range-picker(
      v-model="dateRange"
      :opens="opens"
      :minDate="$moment($moment().startOf('day').subtract(14, 'days').toDate()).format('YYYY-MM-DD')"
      :maxDate="$moment().format('YYYY-MM-DD')"
      :singleDatePicker="singleDatePicker"
      :showWeekNumbers="showWeekNumbers"
      :autoApply="autoApply"
      :linkedCalendars="linkedCalendars"
      @update="handleInput"
      :ranges="(singleDatePicker == true) ? false : ranges"
    )
      div(slot="input" slot-scope="dateRange" style="min-width:170px;")
        i.glyphicon.glyphicon-calendar.fa.fa-calendar.mr-3
        span.text-right {{ $moment(dateRange.startDate).format('YYYY-MM-DD') }} - {{ $moment(dateRange.endDate).format('YYYY-MM-DD') }}
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';

export default {
  components: {
    DateRangePicker
  },
  props: {
    opens: {
      type: String,
      default: "right"
    },
    singleDatePicker: {
      type: Boolean,
      default: false
    },
    showWeekNumbers: {
      type: Boolean,
      default: false
    },
    linkedCalendars: {
      type: Boolean,
      default: true
    },
    autoApply: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dateRange: this.value,
      ranges: {
        'Today': [this.$moment(), this.$moment()],
        'Yesterday': [this.$moment().subtract(1, 'days'), this.$moment().subtract(1, 'days')],
        'This month': [this.$moment().startOf('month'), this.$moment().endOf('month')],
        // 'This year': [this.$moment().startOf('year'), this.$moment().endOf('year')],
        'Last week': [this.$moment().subtract(1, 'week').startOf('week'), this.$moment().subtract(1, 'week').endOf('week')],
        'Last month': [this.$moment().subtract(1, 'month').startOf('month'), this.$moment().subtract(1, 'month').endOf('month')],
      }
    }
  },
  methods: {
    handleInput: function(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("update", currentValue);
    }
  }
};
</script>